export default class Share extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.input = el.querySelector('input');
    this.inputWrapper = el.querySelector('[data-share-input-wrapper]');
    this.successContainer = el.querySelector('[data-share-copy-success]');

    this.state = {
      open: false,
    };
  }

  onMount() {
    this.button = this.query('button');
    this.events.register(this.button.el, 'click', () => this.copyToClipboard());
  }

  copyToClipboard() {
    const { open } = this.state;

    if (!open) {
      navigator.clipboard.writeText(this.input.value)
        .then(() => {
          this.inputWrapper.classList.add('hidden');
          this.successContainer.textContent = this.data.locales.success_message;
          this.input.classList.add('hidden');
          this.successContainer.classList.remove('hidden');
          this.setState({ open: true });

          setTimeout(() => {
            this.inputWrapper.classList.remove('hidden');
            this.successContainer.textContent = '';
            this.input.classList.remove('hidden');
            this.successContainer.classList.add('hidden');
            this.setState({ open: false });
          }, 30000);
        });
    }
  }
}
